import { DefaultApi } from './api'
import { VehicleBodiesData, VehicleTrackerData, VehicleTypesData } from './interfaces'

const path = '/vehicle'

export const listBodies = () =>
  DefaultApi.request<VehicleBodiesData>(`${path}/bodies`, { method: 'GET', withCredentials: true })

export const listTypes = () =>
  DefaultApi.request<VehicleTypesData>(`${path}/types`, { method: 'GET', withCredentials: true })

export const listTrackers = () =>
  DefaultApi.request<VehicleTrackerData>(`${path}/trackers`, { method: 'GET', withCredentials: true })
